function buildVmSizeQuery(location, filters = {}) {
  const params = new URLSearchParams({ location });
  if (filters.cpuArchitecture) params.set('cpuArchitecture', filters.cpuArchitecture);
  if (filters.gpu) params.set('gpu', filters.gpu);
  if (Number.isFinite(filters.maxVcpus)) params.set('maxVcpus', String(filters.maxVcpus));
  if (Number.isFinite(filters.maxResults)) params.set('maxResults', String(filters.maxResults));
  return params.toString();
}

export const azureAksPaths = {
  list: (connectionId) => `/compute/cloud-account-connections/${connectionId}/azure/aks/clusters`,
  create: (connectionId) => `/compute/cloud-account-connections/${connectionId}/azure/aks/clusters`,
  vmSizes: (connectionId, location, filters = {}) =>
    `/compute/cloud-account-connections/${connectionId}/azure/aks/vm-sizes?${buildVmSizeQuery(location, filters)}`,
  detail: (connectionId, resourceGroup, name) =>
    `/compute/cloud-account-connections/${connectionId}/azure/aks/clusters/${encodeURIComponent(resourceGroup)}/${encodeURIComponent(name)}`,
  action: (connectionId, resourceGroup, name, action) =>
    `/compute/cloud-account-connections/${connectionId}/azure/aks/clusters/${encodeURIComponent(resourceGroup)}/${encodeURIComponent(name)}/${encodeURIComponent(action)}`,
  upgradeProfile: (connectionId, resourceGroup, name) =>
    `/compute/cloud-account-connections/${connectionId}/azure/aks/clusters/${encodeURIComponent(resourceGroup)}/${encodeURIComponent(name)}/upgrade-profile`,
};
